if (!customElements.get('weekly-subscription')) {
  customElements.define(
    'weekly-subscription',
    class WeeklySubscription extends HTMLElement {
      connectedCallback() {
        this.formWrappers = [...this.querySelectorAll('[data-weekly-subscription-form]')];
        this.forms = this.formWrappers.map((formWrapper) => formWrapper.querySelector('form')).filter(Boolean);
        this.submitButtons = [...this.querySelectorAll('[data-weekly-subscription-submit]')];
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.productOneVariantId = this.dataset.productOneVariantId;
        this.productTwoVariantId = this.dataset.productTwoVariantId;
        this.sellingPlanId = this.dataset.sellingPlanId;
        this.quantityPerBox = Number.parseInt(this.dataset.quantityPerBox, 10) || 4;
        this.productsReady = this.dataset.productsReady === 'true';
        this.productsAvailable = this.dataset.productsAvailable === 'true';
        this.subscriptionEnabled = this.dataset.subscriptionEnabled === 'true';

        this.forms.forEach((form) => {
          form.addEventListener('submit', (event) => this.onSubmit(event), { capture: true });
        });
        this.updateSubmitState();
      }

      onSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitSubscription(event.currentTarget.closest('.weekly-subscription__purchase-card'));
      }

      updateSubmitState() {
        const disabled = !this.productsReady || !this.productsAvailable || !this.subscriptionEnabled;
        this.submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('strong');
          if (!submitButtonText) return;

          submitButton.disabled = disabled;

          if (!this.productsReady || !this.subscriptionEnabled) {
            submitButtonText.textContent = this.dataset.unavailableLabel;
            return;
          }

          if (!this.productsAvailable) {
            submitButtonText.textContent = this.dataset.soldOutLabel;
            return;
          }

          submitButtonText.textContent = this.dataset.addLabel;
        });
      }

      async submitSubscription(card) {
        const submitButton = card?.querySelector('[data-weekly-subscription-submit]');
        const spinner = submitButton?.querySelector('.loading__spinner');

        if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.productsReady || !this.productsAvailable || !this.subscriptionEnabled) return;

        this.handleError(false, card);
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
        spinner?.classList.remove('hidden');

        const payload = {
          items: this.buildItems(),
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(document.activeElement);
        }

        let cartUpdated = false;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const cartResponse = await response.json();

          if (cartResponse.status) {
            this.publishCartError(cartResponse);
            this.handleError(cartResponse.description || cartResponse.message || this.dataset.unavailableLabel, card);
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.normalizeCartResponse(cartResponse);
          await this.publishCartUpdate(cartResponse);
          this.cart.renderContents(cartResponse);
          cartUpdated = true;
        } catch (error) {
          this.publishCartError({
            errors: error.message,
            message: error.message,
          });
          this.handleError(error.message, card);
        } finally {
          submitButton.classList.remove('loading');
          if (cartUpdated && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }

      buildItems() {
        const properties = {};

        return [
          {
            id: this.productOneVariantId,
            quantity: this.quantityPerBox,
            selling_plan: this.sellingPlanId,
            properties: properties,
          },
          {
            id: this.productTwoVariantId,
            quantity: this.quantityPerBox,
            selling_plan: this.sellingPlanId,
            properties: properties,
          },
        ];
      }

      normalizeCartResponse(cartResponse) {
        if (!cartResponse.key && cartResponse.items?.[0]?.key) {
          cartResponse.key = cartResponse.items[0].key;
        }
      }

      publishCartUpdate(cartResponse) {
        if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return Promise.resolve();

        return publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: this.productOneVariantId,
          cartData: cartResponse,
        });
      }

      publishCartError(cartResponse) {
        if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: this.productOneVariantId,
          errors: cartResponse.errors || cartResponse.description,
          message: cartResponse.message,
        });
      }

      handleError(errorMessage = false, card = this) {
        const errorWrapper = card?.querySelector('[data-weekly-subscription-error-wrapper]');
        const errorMessageElement = card?.querySelector('[data-weekly-subscription-error-message]');
        if (!errorWrapper || !errorMessageElement) return;

        errorWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) errorMessageElement.textContent = errorMessage;
      }
    }
  );
}
